/* Pyramid Cotton — motion.js
   Lightweight scroll motion (no libraries). Elements are tagged and hidden only
   by this script, so if it never runs, nothing is ever invisible. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('js-motion')) return;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* 1. Auto-tag reveal targets, staggered within their group */
  var groups = [
    ['.section-header', '> *'],
    ['.product-grid', '> *'],
    ['.collection-tiles__grid', '> *'],
    ['.benefits__grid', '> *'],
    ['.reviews-grid', '> *'],
    ['.faq__list', '> *'],
    ['.image-with-text__content', '> *'],
    ['.about-content', '> *'],
    ['.footer__top', '> *']
  ];
  groups.forEach(function (g) {
    $$(g[0]).forEach(function (parent) {
      Array.prototype.slice.call(parent.children).forEach(function (el, i) {
        if (el.hasAttribute('data-r')) return;
        el.setAttribute('data-r', '');
        el.style.setProperty('--d', Math.min(i, 8));
      });
    });
  });
  $$('.image-with-text__media, .about-media, .about-mission, .brand-story, .testimonials').forEach(function (el) {
    if (!el.hasAttribute('data-r')) el.setAttribute('data-r', 'mask');
  });

  /* 2. Reveal on scroll */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  $$('[data-r]').forEach(function (el) { io.observe(el); });

  /* 3. Count-up numbers: <span data-count="4.76" data-decimals="2"> */
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, n = parseFloat(el.dataset.count), dec = +(el.dataset.decimals || 0);
      var t0 = performance.now(), dur = 1400;
      var step = function (now) {
        var p = Math.min(1, (now - t0) / dur), v = n * (1 - Math.pow(1 - p, 4));
        el.textContent = v.toFixed(dec);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      cio.unobserve(el);
    });
  }, { threshold: 0.6 });
  $$('[data-count]').forEach(function (el) { cio.observe(el); });

  /* 4. Trust bar becomes a seamless marquee on narrow screens */
  $$('.trust-bar__inner').forEach(function (track) {
    if (track.dataset.mq) return;
    track.dataset.mq = '1';
    var items = Array.prototype.slice.call(track.children);
    items.forEach(function (it) { var c = it.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.classList.add('is-clone'); track.appendChild(c); });
  });

  /* 5. Gentle hero parallax (transform only, rAF-throttled) */
  var heroImg = document.querySelector('.hero__bg-image');
  if (heroImg) {
    var queued = false;
    var onScroll = function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var y = window.scrollY;
        if (y < window.innerHeight * 1.2) heroImg.style.transform = 'translate3d(0,' + (y * 0.18).toFixed(1) + 'px,0) scale(1.06)';
      });
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
